export interface DeelnemerOutput {
  id: number;
  bedrijfsnaam: string;
  contactPersoon: string;
  actief: boolean;
  uoNummer: number;
  vestigingsStraat: string;
  vestigingsNummer: string;
  vestigingsNummerToevoeging: string;
  vestigingsPostcode: string;
  vestigingsPlaats: string;
  toelichtingen: ToelichtingWijziging[];
}

export interface ToelichtingWijziging {
  toelichting: string;
  aangemaaktDoorGebruikerEmail: string;
  aangemaaktOp: Date;
  type: ToelichtingsTypeEnum;
}

export enum AdresLookupStatusEnum {
  "Nog niet bewerkt" = 0,
  "Record wordt bewerkt" = 1,
  "Succesvol bewerkt" = 2,
  "Fout" = 3
}

export enum ZuiveringsplichtVanToepassingEnum {
  "Ja" = 1,
  "Nee" = 2,
  "In behandeling" = 3
}

export enum ZuiveringsplichtwijzeEnum {
  "Nullozing" = 1,
  "Individuele zuivering" = 2,
  "Mobiele zuivering" = 3,
  "Collectieve zuivering" = 4
}

export enum DeelnemerActiefEnum {
  "Definitief inactief" = 0,
  "Actief" = 1,
  "Actief, niet rapportage- maar wel registratieplichtig" = 2,
  "Inactief" = 3
}

export enum ToelichtingsTypeEnum {
  "Onbekend" = 0,
}

export interface DeelnemerInput {
  id: number;
  bedrijfsnaam: string;
  contactPersoon: string;
  actief: boolean;
  vestigingsStraat: string;
  vestigingsNummer: string;
  vestigingsNummerToevoeging: string;
  vestigingsPostcode: string;
  vestigingsPlaats: string;
  telefoonnummer: string;
  email: string;
  straat: string;
  huisNummer: string;
  huisNummerToevoeging: string;
  postcode: string;
  plaats: string;
  gemeenteID: number;
  waterschapID: number;
  uoNummer: number;
  postadresPostcodeCijfers: string;
  vestigingsPostcodeCijfers: string;
  eindDatum?: Date;
  isHoofdvestiging: boolean;
  parent: number;
  parentUONummer: number;
  maatwerkvoorschriftMagBerekenen: boolean;
  maatwerkvoorschriftTeeltwijzeCode: number;
  jaartalMaatwerkVoorschriftToegestaan: number;
  maatwerkvoorschriftDoor: string;
  deelnemerActief: number;
  toelichting: string;
  nrGemeente: string;
  nrWaterschap: string;
  zuiveringsplichtVanToepassing: ZuiveringsplichtVanToepassingEnum;
  zuiveringsplichtWijze: ZuiveringsplichtwijzeEnum;
  toelichtingOpWijziging: string;
  toelichtingOpWijzigingType: ToelichtingsTypeEnum
}